import { assetCategoryState } from '../initialState';
import { storeRemoveItem, storeUpdateObjectInArray } from '../utils/utils';

function withStatus(state, loading, error) {
  return Object.assign({}, state.assetCategoryStatus, { loading, error });
}

function sortedByName(categories) {
  return categories.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '', 'fi'));
}

export default function (state = assetCategoryState, action) {
  switch (action.type) {
    case 'FETCH_ASSET_CATEGORIES_REQUEST': {
      return { ...state, assetCategoryStatus: withStatus(state, true, null) };
    }
    case 'FETCH_ASSET_CATEGORIES_SUCCESS': {
      return { ...state, assetCategories: action.payload, assetCategoryStatus: withStatus(state, false, null) };
    }
    case 'FETCH_ASSET_CATEGORIES_FAIL': {
      return { ...state, assetCategories: [], assetCategoryStatus: withStatus(state, false, action.payload) };
    }
    case 'CREATE_ASSET_CATEGORY_REQUEST':
    case 'UPDATE_ASSET_CATEGORY_REQUEST':
    case 'DELETE_ASSET_CATEGORY_REQUEST': {
      return { ...state, assetCategoryStatus: withStatus(state, true, null) };
    }
    case 'CREATE_ASSET_CATEGORY_SUCCESS': {
      return {
        ...state,
        assetCategories: sortedByName(state.assetCategories.concat([action.payload])),
        assetCategoryStatus: withStatus(state, false, null),
      };
    }
    case 'UPDATE_ASSET_CATEGORY_SUCCESS': {
      return {
        ...state,
        assetCategories: sortedByName(storeUpdateObjectInArray(state.assetCategories, action.payload)),
        assetCategoryStatus: withStatus(state, false, null),
      };
    }
    case 'DELETE_ASSET_CATEGORY_SUCCESS': {
      return {
        ...state,
        assetCategories: storeRemoveItem(state.assetCategories, action.additionalData.itemId),
        assetCategoryStatus: withStatus(state, false, null),
      };
    }
    case 'CREATE_ASSET_CATEGORY_FAIL':
    case 'UPDATE_ASSET_CATEGORY_FAIL':
    case 'DELETE_ASSET_CATEGORY_FAIL': {
      return { ...state, assetCategoryStatus: withStatus(state, false, action.payload) };
    }
    default:
      break;
  }
  return state;
}
